import { IGuardrail } from "../../models/Guardrail.model";

export const FakeGuards: IGuardrail[] = [
  {
    "name": "Sensitive Data Protection Guardrail",
    "description": "Guardrail to protect sensitive information and ensure the inclusion of critical identifiers during the conversion and development process.",
    "logo": "/assets/images/data-protection-logo.png",
    patterns: [
      {
        "type": "regexPattern",
        "pattern": "/\\bAPI_KEY=.+\\b/",
        "value": "Replace hardcoded API keys with environment variables."
      },
      {
        "type": "regexPattern",
        "pattern": "/@Author:.+/",
        "value": "Ensure authorship tags do not reveal personal identifiers."
      },
      {
        "type": "regexPattern",
        "pattern": "/jdbc:.+@.+/",
        "value": "Anonymize database connection strings."
      },
      {
        "type": "regexPattern",
        "pattern": "/serverIp=\\d+\\.\\d+\\.\\d+\\.\\d+/",
        "value": "Replace raw server IP addresses with descriptive placeholders."
      },
      {
        "type": "regexPattern",
        "pattern": "/email\\s*=\\s*['\"].+@.+['\"]/",
        "value": "Mask or replace email addresses with placeholders."
      }
    ],
  },
];
